__turbopack_context__.v({
  "actions": "AddressForm-module-scss-module__vCQ3UW__actions",
  "checkbox": "AddressForm-module-scss-module__vCQ3UW__checkbox",
  "checkboxes": "AddressForm-module-scss-module__vCQ3UW__checkboxes",
  "field": "AddressForm-module-scss-module__vCQ3UW__field",
  "form": "AddressForm-module-scss-module__vCQ3UW__form",
  "row": "AddressForm-module-scss-module__vCQ3UW__row",
  "validationError": "AddressForm-module-scss-module__vCQ3UW__validationError",
});
